import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

const SoftwareTabContent = () => {
    const intl = useIntl();

    const useNewScreenshots = checkFeatureFlagGate(
        featureFlags.gwp9214HomepageScreenshots
    );
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.software.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    const cardOneCtaUrl = useLocalizedHref("/software/jira/templates/scrum");
    const cardTwoCtaUrl = useLocalizedHref(
        "/software/jira/templates/bug-tracking"
    );
    const cardThreeCtaUrl = useLocalizedHref("/software/jira/templates/devops");

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.header",
                        defaultMessage: "Supercharge dev productivity"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.bodytext",
                        defaultMessage:
                            "Plan, track, and release world-class software with the number one software development tool for agile teams"
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.learnMore",
                    defaultMessage: "Learn more about Software"
                }),
                link: useLocalizedHref("/teams/software-development"),
                linkLabel: "Learn more about Software",
                productKey: "home"
            }}
            pictureProps={{
                image: {
                    src: useNewScreenshots
                        ? "https://dam-cdn.atl.orangelogic.com/AssetLink/8t57sjpe86510t2o653k03ly4i64t6m1/software-tab-content-image.webp"
                        : "https://dam-cdn.atl.orangelogic.com/AssetLink/6ec6l1er431c3675ljyq10n08xjpc4h1.webp",
                    alt: "",
                    height: 800,
                    width: 1536
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.software.tabContentEyebrowText",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card1.headerText",
                        defaultMessage: "Scrum"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card1.bodyText",
                        defaultMessage:
                            "Easily plan, track, and manage work across sprints"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardOneCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/80h73kh13eu8gdp17cu328nd42wgdfc0.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card2.headerText",
                        defaultMessage: "Bug Tracking"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card2.bodyText",
                        defaultMessage:
                            "Seamlessly report, track, and prioritize bugs to address development issues"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardTwoCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d714385iejcny2r050x60440qn8axp88.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card3.headerText",
                        defaultMessage: "DevOps"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.software.card3.bodyText",
                        defaultMessage:
                            "Develop, deploy, and manage applications with an open tools approach"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardThreeCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r4dy6nvsu13563346v0610o3de6vfmc2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { SoftwareTabContent };
